<template>
  <div></div>
</template>
<script>

import { mapState } from 'vuex'
import tujiaRedirect from '@/utils/tujiaRedirect.js'
import tujialogin from '@/utils/tujialogin'
import { eventBus } from '@/utils'
import { TCShare } from '@/components/sharePopup'
import { fetchRedpacket } from '@/services/redpacket'
import { base64Encode, base64Decode } from '@/utils/base64'

export default {
  mixins: [tujiaRedirect, tujialogin],
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    ...mapState(['houseFilter'])
  },
  watch: {
    payLoad: {
      async handler(newVal) {
        const isCheckLogin = this.compProps.mate.privateProps.isCheckLogin || false
        const isShare = this.compProps.mate.privateProps.isShare || false
        if (isShare) {
          eventBus.$emit('imgShareHandler')
        }
        const isLogin = await this.isLogin()
        if (isCheckLogin && !isLogin) {
          this.goLoginPage()
          return
        }
        if (newVal.type === 'share') {
          TCShare()
          return
        }
        var isLinkHouseList = null
        if (this.compProps) {
          // 对应后台，“关联房屋来源中的搜索系统”
          isLinkHouseList = this.compProps.mate.isLinkHouseList
        }
        const query = this.$route.query

        // 跳转列表，动态替换cityId
        // 如果有城市选择，用城市选择中的cityId，否则用 url中的， 如果都没有则不做逻辑
        const newCityId = this.houseFilter.cityId || query.cityId

        const checkInDate = this.houseFilter?.checkInDate
        const checkOutDate = this.houseFilter?.checkOutDate
        if (query?.id === 'T20250108142456' && newVal.activeLink) {
          const needVal = { ...newVal }
          // 甄选
          needVal.activeLink = `https://m.tujia.com/hotel_city${newCityId || 48}/6-4164/?checkInDate=${checkInDate}&checkOutDate=${checkOutDate}`
          this.doRedirect(needVal)
          return
        }

        if (isLinkHouseList && newCityId && newVal.type === 'list') {
          // 处理TC
          const needVal = { ...newVal }
          // m站
          if (needVal.activeLink) {
            try {
              // https://m.tujia.com/hotel_beijing/
              // https://m.tujia.com/hotel_beijing/6-1235/
              // https://m.tujia.com/hotel_beijing_5-5_5276/6-1235/
              // => 转换成 https://m.tujia.com/hotel_city${cityId}/
              // 思路找到 二级 path, 然后按照 _ 分割, 替换第二个为city${cityId}
              const url = new URL(needVal.activeLink)
              const pathArr = url.pathname.split('/')
              const cityStr = pathArr[1].split('_')
              cityStr[1] = `city${newCityId}`
              pathArr[1] = cityStr.join('_')
              url.pathname = pathArr.join('/')
              needVal.activeLink = url.href
            } catch (e) {
            }
          }
          // 处理小程序
          if (needVal.mpLink) {
            needVal.mpLink = this.replaceQueryParam(needVal.mpLink, 'cityId', newCityId)
          }
          // T app
          if (needVal.appLink) {
            needVal.appLink = this.replaceQueryParam(needVal.appLink, 'id', newCityId)
          }
          // C app
          if (needVal.cAppLink) {
            // ctrip://wireless/h5?type=5&url=L3JuX2JuYi9tYWluLmpzP0NSTk1vZHVsZU5hbWU9VHVKaWFBcHAmQ1JOVHlwZT0xJmluaXRpYWxQYWdlPVNlYXJjaExpc3QmaWQ9NDg=
            const re = new RegExp(`[?&]${'url'}=([^&#]*)`)
            const match = needVal.cAppLink.match(re)
            let url = base64Decode(match ? match[1] : '')
            if (url) {
              url = this.replaceQueryParam(url, 'id', newCityId)
              needVal.cAppLink = `ctrip://wireless/h5?url=${base64Encode(url)}&type=5`
            }
          }
          this.doRedirect(needVal)
          return
        }
        this.doRedirect(newVal)
      },
      deep: true
    }
  },
  mounted() {
    this.showHandle()
  },
  methods: {
    replaceQueryParam(url, param, newValue) {
      // 正则表达式匹配URL中的查询参数
      const re = new RegExp(`([?&])${param}=.*?(&|$)`, 'i')
      // 替换参数值
      return url.replace(re, `$1${param}=${newValue}$2`)
    },
    async showHandle() {
      try {
        const items = this.compProps?.mate?.items || []
        for (const item of items) {
          if (item && item.showType === 1) { // 红包判断条件
            const activityIdList = item?.activeId?.split(',') || []
            const ret = await fetchRedpacket(activityIdList)
            if (ret && ret.errcode === 0 && ret.data) {
              const canShow = ret.data.redpacketActivities ? ret.data.redpacketActivities.every((item) => {
                // 已领取，未使用，才展示
                return item.receive && !item.used
              }) : false
              this.$set(item, 'show', canShow)
            } else {
              this.$set(item, 'show', false)
              ret.errmsg && this.$toast(ret.errmsg)
            }
          } else {
            this.$set(item, 'show', true)
          }
        }
        this.$emit('init', this.compProps.mate)
      } catch (err) {}
    }
  }
}
</script>
